export const appVersion = APP_VERSION;
